import { BackButton } from "@lecartte/shared-ui/components/RoundIconButton";
import { SavedCardSelector } from '@/features/subscription/components/SavedCardSelector';
import { AutoChargeCheckbox } from '@/features/subscription/components/AutoChargeCheckbox';
import { formatPrice } from '@/features/subscription/components/CardPaymentForm';
import type { SavedCard } from '@/features/subscription/utils/cardUi';

interface SavedCardSelectorStepProps {
  planName: string;
  valueCents: number;
  savedCards: SavedCard[];
  selectedCardId: string;
  setSelectedCardId: (id: string) => void;
  autoChargeExcess: boolean;
  setAutoChargeExcess: (value: boolean) => void;
  error: string | null;
  isPending: boolean;
  onConfirm: (args: { savedCardId: string }) => void;
  onUseNewCard: () => void;
  onBack: () => void;
}

export function SavedCardSelectorStep({
  planName,
  valueCents,
  savedCards,
  selectedCardId,
  setSelectedCardId,
  autoChargeExcess,
  setAutoChargeExcess,
  error,
  isPending,
  onConfirm,
  onUseNewCard,
  onBack,
}: SavedCardSelectorStepProps) {
  const effectiveSelectedId = selectedCardId || savedCards.find((c) => c.isPrimary)?.id || savedCards[0]?.id || '';

  return (
    <div className="py-4">
      <SavedCardSelector
        cards={savedCards}
        selectedCardId={effectiveSelectedId}
        onSelectCard={({ cardId }) => setSelectedCardId(cardId)}
        onUseNewCard={onUseNewCard}
        onConfirm={() => onConfirm({ savedCardId: effectiveSelectedId })}
        isPending={isPending}
        error={error}
        confirmLabel={`Confirmar — ${formatPrice({ valueCents })}`}
        footer={<AutoChargeCheckbox checked={autoChargeExcess} onChange={setAutoChargeExcess} />}
        header={
          <div className="flex items-center gap-3">
            <BackButton onClick={onBack} />
            <div>
              <p className="font-semibold text-slate-900">Escolher cartão</p>
              <p className="text-xs text-slate-500">Plano {planName} — {formatPrice({ valueCents })}</p>
            </div>
          </div>
        }
      />
    </div>
  );
}
